export const getShortUserName = (fullname?: string) => {
  if (!fullname) return '';
  const fullnameArray = fullname.trim().split(' ');
  return fullnameArray.map((partName, i) => i === 0 ? partName : `${partName[0]}.`).join(' ');
};
